import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

// 检查用户是否已登录
const isAuthenticated = () => {
  const user = localStorage.getItem('blog_current_user');
  return !!user;
};

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  
  if (!isAuthenticated()) {
    // 保存当前路径，登录后可以跳转回来
    return <Navigate to="/auth" state={{ from: location.pathname }} replace />;
  }

  return children;
};

// 加载中组件
export const LoadingScreen = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#fafafa'
  }}>
    <Spin 
      indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
      tip="正在加载..."
    />
  </div>
);

export default PrivateRoute;